import { Component, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entry } from 'contentful';

import { AnalyticsService } from '@src/app/shared/services/fb-analytics.service';
import { ContentService } from '@src/app/shared/services/content.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  path: string;
  crumbs: string[] = ['portfolio'];
  crumbsExclude: string[] = ['entries']
  entries: Entry<any>[];

  constructor(
    private analyticsService: AnalyticsService,
    private contentService: ContentService
  ) {
    this.entries = this.router.getCurrentNavigation()?.extras?.state?.data

    this.route.params.subscribe(() => {
      this.getCrumbs();
    })
  }

  getCrumbs(): void {
    this.path = this.router.url;
    this.crumbs = [this.crumbs[0]];

    this.path.split('/').forEach((e) => {
      if (e && !this.crumbsExclude.includes(e))
        this.crumbs.push(e);
    })
  }

  crumbLink(name: string, depth: number): string {
    if (depth === 0)
      return '/'

    return this.crumbs.slice(1, depth + 1).join('/');
  }

  // Lifecycle Hooks

  ngOnDestroy(): void {
    
  }
}
